export default __webpack_public_path__ + "static/media/27_2_3.815f5eaf.png";